var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVolanteIcone(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.8332 7.49984H9.33317M6.99984 13.3332C10.2216 13.3332 12.8332 10.7216 12.8332 7.49984C12.8332 4.27809 10.2216 1.6665 6.99984 1.6665C3.77809 1.6665 1.1665 4.27809 1.1665 7.49984C1.1665 10.7216 3.77809 13.3332 6.99984 13.3332ZM6.99984 13.3332V9.83317V13.3332ZM1.1665 7.49984H4.6665H1.1665Z",
    stroke: "#292926",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33317 7.49984C9.33317 8.11868 9.08734 8.71217 8.64975 9.14975C8.21217 9.58734 7.61868 9.83317 6.99984 9.83317C6.381 9.83317 5.78751 9.58734 5.34992 9.14975C4.91234 8.71217 4.6665 8.11868 4.6665 7.49984C4.6665 6.881 4.91234 6.28751 5.34992 5.84992C5.78751 5.41234 6.381 5.1665 6.99984 5.1665C7.61868 5.1665 8.21217 5.41234 8.64975 5.84992C9.08734 6.28751 9.33317 6.881 9.33317 7.49984V7.49984Z",
    stroke: "#292926",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolanteIcone);
export default __webpack_public_path__ + "static/media/volante-icone.eb48392831ae6c562a168c92efe2d640.svg";
export { ForwardRef as ReactComponent };